<template lang="pug">
	ul.navbar-nav.account-button(v-if="User.currentUser")
		li.nav-item.px-3
			.account
				.user-photo(:style="{ backgroundImage: 'url(' + User.currentUser.photo || 'Images/Screens/Login/default-user-icon.png' + ')' }" v-pseudo-modal-show="'account-dropdown'")
				.active-publisher-contacts-count.badge.badge-danger(v-show="Publisher.getActivePublisherContactsCount() > 0") {{Publisher.getActivePublisherContactsCount()}}
		.dropdown-menu(v-pseudo-modal="'account-dropdown'" :style="{'max-height': `90vh`}" ref="dropdownMenu")
			.publishers(v-if="User.currentUser.Tags['admin'] && !Metadata.Config['feature-single-publisher']")
				b-dropdown-header(tag="div" class="text-center")
					strong Active publishers
				b-dropdown-item(v-for="publisher in publishers" :key="publisher.id" :class="{selected: Publisher.SelectedPublisher && Publisher.SelectedPublisher.id === publisher.id}" v-on:click="choosePublisher(publisher.id)" v-if="publisher.active === 1")
					.menu-item-content
						.menu-item-title(:class="{online: isOnlineUsersExist(publisher.id) && Layout.isFeatureEnabled('online-users', 'online-users-publisher-color')}") {{ publisher.title }}
						.menu-item-online(v-if="Layout.isFeatureEnabled('online-users', 'online-users-publisher-list')")
							OnlineUsersLocal(:filter="getFilterForOnlineUsers(publisher.id)" max-count="5")
			.administration(v-if="User.currentUser.Tags['admin']")
				b-dropdown-header(tag="div" class="text-center")
					strong Administration
				b-dropdown-item(@click="cloneProject()")
					span Clone project repository
						.icon.fa.fa-spinner.fa-spin(v-if="Monitoring.getChannelState('clone-project') !== 'done'")
				b-dropdown-item(v-if="Metadata.Config['feature-playable-templates']" @click="cloneTemplate()")
					span Clone template repository
						.icon.fa.fa-spinner.fa-spin(v-if="Monitoring.getChannelState('clone-template') !== 'done'")
				b-dropdown-item(v-if="!Metadata.Config['feature-single-publisher']" @click="showPublishers()")
					span Publisher list
				b-dropdown-item(v-if="!Metadata.Config['feature-single-publisher'] && User.currentUser.Tags['super-admin']" @click="showPublisherContacts()")
					span Customer contacts
				b-dropdown-item(@click="showUsers()")
					span User list
				b-dropdown-item(@click="updateUsersCache()")
					span Update users cache
				b-dropdown-item(@click="updateMetadataCache()")
					span Update metadata cache
			.publisher(v-if="User.currentUser && (User.currentUser.Tags['publisher-admin'] || User.currentUser.Tags['admin']) && Publisher.SelectedPublisher")
				b-dropdown-header(tag="div" class="text-center")
					strong {{Publisher.SelectedPublisher.title}}
				b-dropdown-item(class="company-settings" @click="openPublisherSettings()")
					span Company settings
				b-dropdown-item(class="company-users" @click="openPublisherUsers()")
					span Users
				b-dropdown-item(@click="cloneProject()" v-if="checkGitClone()")
					span Clone project repository
						.icon.fa.fa-spinner.fa-spin(v-if="Monitoring.getChannelState('clone-project') !== 'done'")
			.account
				b-dropdown-header(tag="div" class="text-center")
					strong Account
				b-dropdown-item(v-if="User.currentUser && User.currentUser['publisher_id'] !== 9" @click="openUserProfile()")
					span Profile
				b-dropdown-item(@click="User.logout()")
					span Logout
</template>

<script>

	import Screen 				from './../../mixins/screen';

	import { Layout } 			from './../../services/Layout';
	import { User } 			from './../../services/User';
	import { Publisher } 		from './../../services/Publisher';
	import { Project } 			from './../../services/Project';
	import { Asset } 			from './../../services/Asset';
	import { Monitoring } 		from './../../services/Monitoring'

	import OnlineUsersLocal		from './../../components/Header/OnlineUsersLocal';

	export default {
		name: "AccountButton",
		mixins: [Screen],
		screen: {
			updateOn: ["Publishers Changed", "Selected Publisher Changed", "Current User Changed", "Users Online Status Changed", "User Online Status Changed",
				"User Online Status Added", "User Online Status Removed", "Metadata Loaded", "Publishers Exists Changed", "Customer Contacts Changed"],
			events: {
				"Monitoring Channel Updated": function() {
					this.update();
				},
				"Pseudo Modal Showed account-dropdown": function() {

					if (this.$refs.dropdownMenu) {

						this.$refs.dropdownMenu.removeEventListener('scroll', this.dispatchScrollEvent);
						this.$refs.dropdownMenu.addEventListener('scroll', this.dispatchScrollEvent);

					}

				}
			}
		},
		components: {
			OnlineUsersLocal
		},
		data() {

			this.User = User;
			this.Publisher = Publisher;
			this.Project = Project;
			this.Monitoring = Monitoring;

			this.publishers = _.values(Publisher.Publishers);

			return {
				showed: true,
				compressionCacheSize: null
			}

		},
		methods: {
			collectData() {

				this.publishers = _.values(Publisher.Publishers);
				this.compressionCacheSize = Asset.CompressionCacheSize || 0;

			},
			isOnlineUsersExist(publisherId) {

				return _.find(User.usersOnlineStatus.Users, userData => userData.publisherId === publisherId);

			},
			getFilterForOnlineUsers(publisherId) {

				return userData => userData.publisherId === publisherId;

			},
			choosePublisher(publisher_id) {

				Publisher.selectPublisher(publisher_id);

				if (Layout.page !== 'playables' && Layout.page !== 'banners') Layout.setPage('playables');

				Broadcast.call("Pseudo Modal Hide", ['account-dropdown']);

			},
			cloneProject() {

				if (Monitoring.getChannelState('clone-project') !== 'done') {

					Broadcast.call("Show MonitoringLog", ["clone-project"]);

				} else {

					Broadcast.call("Show CloneProjectRepository");

				}

				Broadcast.call("Pseudo Modal Hide", ['account-dropdown']);

			},
			cloneTemplate() {

				if (Monitoring.getChannelState('clone-template') !== 'done') {

					Broadcast.call("Show MonitoringLog", ["clone-template"]);

				} else {

					Broadcast.call("Show CloneTemplateRepository");

				}

				Broadcast.call("Pseudo Modal Hide", ['account-dropdown']);

			},
			updateUsersCache() {

				Server.sendToSocket({
					UpdateUsersCache: true
				});

				Broadcast.call("Pseudo Modal Hide", ['account-dropdown']);

			},
			updateMetadataCache() {

				Server.sendToSocket({
					UpdateMetadataCache: true
				});

				Broadcast.call("Pseudo Modal Hide", ['account-dropdown']);

			},
			showPublishers() {

				Layout.setPage('publisher-list');

				Broadcast.call("Pseudo Modal Hide", ['account-dropdown']);

			},
			showPublisherContacts() {

				Layout.setPage('publisher-contacts');

				Broadcast.call("Pseudo Modal Hide", ['account-dropdown']);

			},
			showUsers() {

				Layout.setPage('user-list');

				Broadcast.call("Pseudo Modal Hide", ['account-dropdown']);

			},
			openPublisherSettings() {

				Layout.setPage('publisher-settings');

				Broadcast.call("Pseudo Modal Hide", ['account-dropdown']);

			},
			openPublisherUsers() {

				Layout.setPage('publisher-users');

				Broadcast.call("Pseudo Modal Hide", ['account-dropdown']);

			},
			openUserProfile() {

				Layout.setPage('user-profile', {userId: User.currentUser.id});

				Broadcast.call("Pseudo Modal Hide", ['account-dropdown']);

			},
			checkGitClone() {

				return (Publisher && Publisher.SelectedPublisher && Publisher.SelectedPublisher.options && Publisher.SelectedPublisher.options['GitClone']);

			},
			dispatchScrollEvent() {

				Broadcast.call("Account Settings Dropdown Scroll");

			}
		}
	}
</script>

<style lang="sass">

	ul.account-button
		list-style: none
		position: relative

		a.nav-link.download
			font-size: 25px
			line-height: 23px

		.dropdown-menu
			position: absolute
			left: -197px
			top: 43px
			width: 250px
			display: block
			z-index: 10000
			box-shadow: 0 0 10px rgba(0, 0, 0, 0.5)
			line-height: 1

			.icon
				margin-left: 6px

			.menu-item-content
				display: flex
				flex-direction: row
				justify-content: stretch

				.menu-item-title
					display: flex

					&.online
						color: #4dbd74

				.menu-item-online
					display: flex
					width: 100%
					margin-left: 10px

					.c-avatar-status
						display: none

			li:not(:first-child)
				.dropdown-item
					border-top: 1px solid rgba(0, 0, 0, 0.2)

			li:nth-child(2)
				.dropdown-item
					border-top: none

			li.selected

				.dropdown-item
					background-color: #20a8d8

					.menu-item-title.online
						color: #ffffff

		.publishers, .administration, .publisher
			border-bottom: 1px solid #23282c

		.dropdown-menu
			overflow-x: hidden
			overflow-y: auto

			&::-webkit-scrollbar
				position: fixed
				width: 8px
				margin-left: -8px
				-webkit-appearance: none
				appearance: none

			&::-webkit-scrollbar-track
				background-color: rgba(0, 0, 0, 0.08)

			&::-webkit-scrollbar-thumb
				background-color: rgba(0, 0, 0, 0.36)
				background-clip: content-box
				border-color: transparent
				border-radius: 5px

		.nav-link,
		.nav-link:focus
			color: #c8ced3

		.nav-link:hover
			color: #fff

		.user-photo
			background: center / auto 100% no-repeat
			width: 35px
			height: 35px
			border-radius: 35px
			cursor: pointer
			image-rendering: -webkit-optimize-contrast

		.active-publisher-contacts-count
			position: absolute
			right: 5px
			top: -5px

</style>

